@if (!store.video.enabled()) {
  <div class="submit-button" (click)="call()" tabindex="0">
    <span i18n-title title="Start a Call" i18n>📞️</span> <label i18n>call</label>
  </div>
} @else {
  <div class="submit-button" (click)="hangup()" tabindex="0">
    <span i18n-title title="End a Call" i18n>👋️</span> <label i18n>hangup</label>
  </div>

  <div class="call-layout" [class.two-person]="isTwoPersonCall()">
    <!-- Featured video (callee for 2-person, active speaker for group) -->
    @if (featuredStream(); as featured) {
      <div class="featured-section">
        <div class="stream-label glass">
          @if (authorExts().get(featured.tag); as x) {
            <a class="user tag"
               [routerLink]="['/tag', x.tag + x.origin]"
               [appTitle]="x">{{ x.name }}</a>
          }
        </div>
        @for (s of featured.streams; track s.stream.id) {
          <video [srcObject]="s.stream"
                 [class.loading]="!s.playing"
                 (playing)="store.video.playing(featured.tag, s.stream.id)"
                 class="featured-video" autoplay playsinline></video>
        } @empty {
          <div class="loading video-placeholder featured-video"></div>
        }
      </div>
    }
    <div class="video-grid">
      @for (u of gridStreams(); track u.tag) {
        <div class="grid-tile">
          <div class="stream-label glass">
            @if (authorExts().get(u.tag); as x) {
              <a class="user tag"
                 [routerLink]="['/tag', x.tag + x.origin]"
                 [appTitle]="x">{{ x.name }}</a>
            }
          </div>
          @for (s of u.streams; track s.stream.id) {
            <video
              [srcObject]="s.stream"
              [class.loading]="!s.playing"
              (playing)="store.video.playing(u.tag, s.stream.id)"
              autoplay
              playsinline
              tabindex="0"
              (click)="setSpeaker(u.tag)"
              (keydown.enter)="setSpeaker(u.tag)"
              (keydown.space)="setSpeaker(u.tag)"></video>
          } @empty {
            <div class="loading video-placeholder"></div>
          }
        </div>
      }
      @if (store.video.stream()) {
        <div class="grid-tile">
          <div class="stream-label glass">
            <a class="user tag"
               [routerLink]="['/tag', store.account.tag()]"
               [appTitle]="store.account.ext()" i18n>⭕️ Me</a>
          </div>
          <video [srcObject]="store.video.stream()" class="mirror-video" autoplay playsinline [muted]="true"></video>
        </div>
      }
      @for (tag of hungup(); track tag) {
        <div class="grid-tile">
          <div class="stream-label glass">
            @if (authorExts().get(tag); as x) {
              <a class="user tag"
                 [routerLink]="['/tag', x.tag + x.origin]"
                 [appTitle]="x">{{ x.name }}</a>
            }
          </div>
          <div class="hungup video-placeholder" i18n-title title="Hung up" i18n>👋️</div>
        </div>
      }
    </div>
  </div>
}
